import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronUp } from 'feather-icons-react/build/IconComponents';
import AddPurchaseReturn from '../../core/modals/purchases/addpurchasereturn';
import EditPurchaseReturns from '../../core/modals/purchases/editpurchasereturns';
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
import { useToast } from '../../Toaster/ToastContext';
import Loader from '../loader/loader';
import { apiClient } from '../../services/apiClient';
import { Table } from 'antd';

const PurchaseReturns = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [purchases, setPurchases] = useState([]);
    const [filteredPurchases, setFilteredPurchases] = useState([]);
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const hasFetched = useRef(false);

    const fetchPurchases = async () => {

        if (hasFetched.current) return;
        setLoading(true);
        try {
            const response = await apiClient.post('/get-all-purchase', {
                pageIndex: 0,
                pageSize: 50,
                previousPageIndex: 0,
            })
            if (response.status) {
                const returnPurchases = (response.purchases || []).filter(
                    (purchase) => purchase.status && typeof purchase.status === 'string' && purchase.status.toLowerCase() === 'returned'
                );
                setPurchases(returnPurchases);
                setFilteredPurchases(returnPurchases);
            } else {
                setPurchases([]);
                setFilteredPurchases([]);
            }
        } catch (error) {
            showToast(error.message || 'Failed to fetch purchases', 'error', 'Purchases');
        } finally {
            setLoading(false);
            hasFetched.current = true;
        }
    };

    useEffect(() => {
        fetchPurchases();
    }, []);

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setFilteredPurchases(
            purchases.filter((purchase) =>
                (purchase.supplier_name && typeof purchase.supplier_name === 'string' ? purchase.supplier_name.toLowerCase().includes(term) : false) ||
                (purchase.reference && typeof purchase.reference === 'string' ? purchase.reference.toLowerCase().includes(term) : false)
            )
        );
    };

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );
    // const MySwal = withReactContent(Swal);

    // const showConfirmationAlert = () => {
    //     MySwal.fire({
    //         title: 'Are you sure?',
    //         text: 'You won\'t be able to revert this!',
    //         showCancelButton: true,
    //         confirmButtonColor: '#00ff00',
    //         confirmButtonText: 'Yes, delete it!',
    //         cancelButtonColor: '#ff0000',
    //         cancelButtonText: 'Cancel',
    //     }).then((result) => {
    //         if (result.isConfirmed) {

    //             MySwal.fire({
    //                 title: 'Deleted!',
    //                 text: 'Your file has been deleted.',
    //                 className: "btn btn-success",
    //                 confirmButtonText: 'OK',
    //                 customClass: {
    //                     confirmButton: 'btn btn-success',
    //                 },
    //             });
    //         } else {
    //             MySwal.close();
    //         }

    //     });
    // };

    const columns = [
        {
            title: "Supplier Name",
            dataIndex: "supplier_name",
            sorter: (a, b) => (a.supplier_name || '').length - (b.supplier_name || '').length,
        },
        {
            title: "Date",
            dataIndex: "date",
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            render: (text) => {
                const date = new Date(text);
                return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).split('/').join('-');
            },
        },
        {
            title: "Reference",
            dataIndex: "reference",
            sorter: (a, b) => (a.reference || '').length - (b.reference || '').length,
        },
        {
            title: "Status",
            dataIndex: "status",
            sorter: (a, b) => (a.status || '').length - (b.status || '').length,
            render: (text) => (
                <span className="badge" style={{ backgroundColor: '#D10000' }}>
                    {text === 'returned' ? 'Returned' : text}
                </span>
            ),
        },
        {
            title: "Grand Total ($)",
            dataIndex: "total",
            sorter: (a, b) => (a.total || 0) - (b.total || 0),
            render: (text) => `$${text || '0.00'}`,
        },
        {
            title: "Paid ($)",
            dataIndex: "paid",
            sorter: (a, b) => (a.paid || 0) - (b.paid || 0),
            render: (text) => `$${text || '0.00'}`,
        },
        {
            title: "Due ($)",
            dataIndex: "due",
            sorter: (a, b) => (a.due || 0) - (b.due || 0),
            render: (text) => `$${text || '0.00'}`,
        },
        {
            title: "Payment Status",
            dataIndex: "payment_status",
            sorter: (a, b) => (a.payment_status || '').length - (b.payment_status || '').length,
            render: (text) => (
                <span
                    className="badge"
                    style={{
                        backgroundColor: text === 'paid' ? '#EBF8F2' : '#FFE5E5',
                        color: text === 'paid' ? '#49BE96' : '#FF4D4F',
                    }}
                >
                    {text === 'paid' ? 'Paid' : 'Unpaid'}
                </span>
            ),
        },
    ];

    return (
        <div>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Purchase Return List</h4>
                                <h6>Manage your Returns</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        {/* <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-sales-new"
                            >
                                 <PlusCircle className="me-2"/>
                                Add Purchase Return
                            </Link>
                        </div> */}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            onChange={handleSearch}
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={filteredPurchases}
                                    rowKey={(record) => record.id || record.reference}
                                    rowSelection={null}
                                />
                            </div>
                            {/* <div className="table-responsive">
                                <table className="table datanew">
                                    <thead>
                                        <tr>
                                            <th>Supplier Name</th>
                                            <th>Date</th>
                                            <th>Reference</th>
                                            <th>Status</th>
                                            <th>Grand Total ($)</th>
                                            <th>Paid ($)</th>
                                            <th>Due ($)</th>
                                            <th>Payment Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredPurchases.length > 0 ? (
                                            filteredPurchases.map((purchase, index) => (
                                                <tr key={index}>
                                                    <td>{purchase.supplier_name}</td>
                                                    <td>
                                                        {purchase.date
                                                            ? purchase.date.split('-').reverse().join('-')
                                                        : 'N/A'}
                                                    </td>
                                                    <td>{purchase.reference}</td>
                                                    <td>
                                                        {purchase.status === 'returned' && (
                                                            <span className="badge" style={{backgroundColor: '#D10000'}}>Returned</span>
                                                        )}
                                                    </td>
                                                    <td>${purchase.total || '0.00'}</td>
                                                    <td>${purchase.paid || '0.00'}</td>
                                                    <td>${purchase.due || '0.00'}</td>
                                                    <td>
                                                        {purchase.payment_status === 'unpaid' && (
                                                            <span className="badge" style={{backgroundColor: '#FFE5E5', color: '#FF4D4F'}}>Unpaid</span>

                                                        )}
                                                        {purchase.payment_status === 'paid' && (
                                                            <span className="badge" style={{backgroundColor: '#EBF8F2', color: '#49BE96'}}>Paid</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    No purchases found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> */}
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
            <AddPurchaseReturn/>
            <EditPurchaseReturns/>
        </div>
    )
}

export default PurchaseReturns
